<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/talkPolicies"></imgBigCards>

    <div class="box-content">
      <div class="content-left">
        <div class="left-one">
          <div class="one-title">
            <p>
              {{ mydata.articleInfo.title }}
            </p>
            <P>
              <!-- <span>参与对象：{{ mydata.articleInfo.participant }}</span> -->
              <span
                >发表时间：{{
                  dayjs(mydata.articleInfo.release_time * 1000).format(
                    "YYYY-MM-DD"
                  )
                }}</span
              >
              <span style="margin-right: 34px"
                >来源：{{ mydata.articleInfo.source }}</span
              >
              <span
                >关键词：
                <span
                  v-for="(item, index) in mydata.articleInfo.tags"
                  :key="index"
                  style="margin-right: 10px"
                  >{{ item.name }}</span
                >
              </span>
            </P>
          </div>
          <div class="one-content">
            <!-- <img src="@/assets/image 13 (1).png" alt="" /> -->
            <p class="tableA" v-html="mydata.articleInfo.content"></p>
          </div>

          <div class="one-foot">
            <p
              style="cursor: pointer"
              @click="goPrevOrNext(mydata.articleInfo.prev.id)"
              v-if="mydata.articleInfo.prev?.title !== undefined"
            >
              上一篇：{{ mydata.articleInfo.prev?.title }}
            </p>
            <p
              style="cursor: pointer"
              @click="goPrevOrNext(mydata.articleInfo.next.id)"
              v-if="mydata.articleInfo.next?.title !== undefined"
            >
              下一篇： {{ mydata.articleInfo.next?.title }}
            </p>
          </div>
        </div>
      </div>

      <!-- 右侧推荐区域 -->
      <div class="content-right ">
        <!-- 超值推荐 -->
        <rightCardGreatValue title="超值推荐"></rightCardGreatValue>
      </div>
    </div>
  </div>
</template>

<script setup>
// 必备好书
import rightCardGreatValue from "@/components/rightCardGreatValue/index2.vue";

import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";

import { reactive, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

import activityResultsCard from "@/components/activityResultsCard/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/talkPoliciesDetails")) {
      return;
    }
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log(res);
    mydata.articleInfo = res.data;
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.articleInfo.title;
  });
}

// init();

//必备好书详情
function fn() {
  router.push({
    path: "/layout/list/booksDetails",
  });
}

function goPrevOrNext(id) {
  if (id === undefined) {
    return;
  }
  router.push({
    path: "/layout/list/talkPoliciesDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;

    /////左边内容部分
    .content-left {
      width: 375px;
      // height: 1608px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      ////左边---第一个模块---卷子标题盒子
      .left-one {
        // width: 860px;
        background-color: #ffffff;
        padding: 16px 16px 20px 16px;
        .one-title {
          width: 343px;
          // height: 90px;
          // border: 1px solid red;
          p:nth-of-type(1) {
            min-height: 28px;
            font-size: 18px;
            font-weight: 700;
            color: #333333;

            line-height: 28px;
            // height: 56px;
            display: -webkit-box;
            -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            text-overflow: ellipsis; //文本溢出 用省略号显示
            -webkit-line-clamp: 2; //几行
            overflow: hidden;
          }
          p:nth-of-type(2) {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #888888;
            margin-top: 12px;
            > span {
              margin-right: 34px;
            }
          }
        }
        .one-content {
          width: 343px;
          // height:1824px;
          // border: 1px solid blue;
          margin-top: 24px;
          // img {
          //   width: 720px;
          //   height: 480px;
          //   margin: 0 auto;
          //   display: block;
          //   // border:1px solid yellow;
          // }
          p {
            margin-top: 24px;
            white-space: pre-wrap;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            // color:red;
          }
        }
        .one-button {
          //按钮
          :deep(.el-button.el-button--primary.is-round) {
            width: 170px;
            height: 46px;
            border-radius: 30px;
            color: #ffffff;
            font-size: 14px;
            font-weight: 400;
            margin: 0 auto;
            display: block;
            margin-top: 26px;
          }
        }
        .one-foot {
          width: 343px;
          // height: 84px;
          // border: 1px solid red;
          border-top: 1px dashed #cccccc;
          margin-top: 26px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //文本溢出 用省略号显示
            overflow: hidden;
          }
          p:nth-of-type(1) {
            margin-top: 24px;
          }
          p:nth-of-type(2) {
            margin-top: 16px;
          }
          p:hover {
            color: #009de0;
          }
        }
      }

      ////左边---第二个模块
      .left-two {
        margin: 0 auto;
        margin-bottom: 16px;
        overflow: hidden;
        //////活动成果部分
        .left-two-box {
          width: 800px;
          // height: 228px;
          // border: 1px dashed yellow;
          overflow: hidden;

          :deep(.box-column) {
            height: 100%;
            margin-top: 16px;
            li:hover {
              p:nth-of-type(2) {
                color: #009de0;
              }
            }

            li {
              margin-left: 20px;
              // display: flex;
              // justify-content: space-between;
              // align-items: center;
              margin-bottom: 8px;
              // border: 1px solid red;
              position: relative;
              p:first-of-type {
                font-size: 14px;
                margin-bottom: 8px;
                line-height: 24px;
                white-space: nowrap; //不折行
                text-overflow: ellipsis; //文本溢出 用省略号显示
                overflow: hidden;
              }
              p:nth-of-type(2) {
                font-size: 14px;
                font-weight: 400;
                color: #888888;
                position: absolute;
                right: 0px;
                top: 2px;
              }
            }
            li:nth-last-of-type(1) {
              margin-bottom: 0px;
            }
            // .column-title {
            //   border-bottom: 1px solid #cccccc;
            //   > p {
            //     // display: none;
            //   }
            // }
            .column-content {
              height: 220px;

              overflow: hidden;
              overflow-y: auto;
            }
          }
        }
      }
    }

    /////右边推荐区域
    .content-right  {
    margin-top:16px;
    }
  }
}
// :deep(.left-two-box .column-content) {
//   height: 156px !important;
//   border: 1px solid red;
// }
</style>
